import { useState } from 'react';
import { useDrag } from 'react-dnd';
import Swal from 'sweetalert2';

const Cartao = ({ id, mensagemSistema, title, codigo, showModal, status, onShowPreview, isContaConciliacaoInteligente, isBanco, isSalario, isFornecedor, configuracao }: { id: number, title: String, secondTitle: string, codigo: String, showModal: Function, percent: number, status: string, onShowPreview: Function, isContaConciliacaoInteligente: boolean, isBanco: boolean, esteiraID: number, isSalario: boolean, mensagemSistema: any[], isFornecedor: boolean, configuracao?: boolean }) => {

    const [{ opacity }, dragRef] = useDrag(() => ({
        type: 'CARD',
        item: { id, codigo, status, isContaConciliacaoInteligente, isBanco, isSalario, isFornecedor, configuracao },
        collect: (monitor) => ({
            opacity: monitor.isDragging() ? 0.5 : 1,
        })
    }), []);

    const [loadingReport, setLoadingReport] = useState<boolean>(false);

    return (
        <div onClick={() => {
            showModal(codigo);
        }} ref={dragRef} style={{ opacity, width: '100%', height: 'auto', backgroundColor: '#EBECF0', padding: '10px 5px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'start', width: '100%', backgroundColor: (mensagemSistema?.length ?? 0) > 0 ? 'rgba(192, 57, 43, 0.1)' : 'white', borderRadius: '2px', padding: '5px' }}>
                {mensagemSistema && mensagemSistema.length > 0 && <div style={{ width: '50px', height: '5px', backgroundColor: 'red', borderRadius: '15px', marginBottom: '5px' }} />}
                <p style={{ fontSize: '14px', color: '#172b4d', margin: '0', textAlign: 'justify' }}>{codigo} - {title}</p>
                {loadingReport ? (
                    <div className="spinner-border text-success" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                ) : (
                    <div style={{ display: 'flex' }}>
                        <i onClick={(e) => {
                            setLoadingReport(true);
                            e.stopPropagation();
                            onShowPreview(() => setLoadingReport(false));
                        }} className='fa fa-eye fs-4 mt-2' style={{ color: 'gray' }} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default Cartao;